export default __webpack_public_path__ + "static/media/TradingVillageMap.356337f3.jpg";